<div class="card-wrapper {{cssClass}}">
  <p-panel [collapsed]="collapsedPanel">
    <p-header>
      <section *ngIf="titles && titles.length > 0" class="card-title expandable-card-header">
        <span *ngFor="let title of titles; let i = index"
              [ngClass]="'level-'+i">
          <ng-container [ngSwitch]="title.type">
            <a *ngSwitchCase="'link'"
               class="link"
               target="_blank"
               [href]="title.link">{{title.text}}</a>
            <span *ngSwitchDefault>{{title.text}}</span>
          </ng-container>
        </span>
      </section>
      <div class="card-header-container">
        <gen-dynamic-form class="content" *ngIf="headerFormId"
                          [editMode]="cardEditMode"
                          [disabled]="disabled"
                          [formData]="data"
                          [formName]="headerFormId"
                          [listenToDataChange]="true"
                          [reInitializeForm]="resetForm"
                          [submitted]="submitted"
                          [updatedFieldsContextType]="'clinicalRecommendation'"
                          [updatedFieldsContext]="data.id"
        >
        </gen-dynamic-form>

        <div class="actions">
          <span class="action"  *ngIf="isSelectable">
            <gen-toggle-switch
              [active]="isSelected$|async"
              (statusUpdate)="selectDrug($event)"
            ></gen-toggle-switch>
          </span>
          <span class=" action glyphicon glyphicon-pencil pointer " *ngIf="editable" (click)="toggleEdit()"></span>
          <span class=" action glyphicon pointer "
            [ngClass]="{
              'glyphicon-chevron-down': collapsedPanel,
              'glyphicon-chevron-up': !collapsedPanel
            }"
            (click)="toggleCollapsed()"
          ></span>
        </div>
      </div>
    </p-header>

    <gen-dynamic-form *ngIf="bodyFormId && !collapsedPanel"
                      [editMode]="cardEditMode"
                      [disabled]="disabled"
                      [formData]="data"
                      [formName]="bodyFormId"
                      [formVertical]="true"
                      [reInitializeForm]="resetForm"
                      [submitted]="submitted"
                      [updatedFieldsContext]="data.id"
                      [updatedFieldsContextType]="'clinicalRecommendation'"
    >
    </gen-dynamic-form>

    <p-footer class="buttons-wrapper" *ngIf="saveButtonsVisible">
      <gen-button class="save-button" [type]="'primary'" *ngIf="saveButtonsVisible"  [text]="'Save'" (click)="updateContent()"></gen-button>
      <gen-button class="cancel-button" [type]="'quite'" *ngIf="saveButtonsVisible" [text]="'Cancel'" (click)="cancelUpdate()"></gen-button>
    </p-footer>
  </p-panel>
</div>

